import React, { Fragment } from 'react';
import { translate } from '../Services/translation';
import CartGridSearchResults from './CartGrid/CartGridSearchResults';
const QuickSearchResult = ({ result, selectedItem, searchUrl }) => {
  return (
    <div className='quick-search-result-wrapper'>
      {result &&
        result
          .map((o) => o.category)
          .filter((value, index, self) => self.indexOf(value) === index)
          .map((category, kindex) => {
            return (
              <Fragment key={`RESULT-${kindex}`}>
                {category === translate('searchcategory.product') && (
                  <CartGridSearchResults
                    orderRows={result.filter((o) => o.category === category)}
                  />
                )}
                {category === 'ShowAll' && (
                  <div className='misc-result-wrapper'>
                    <a className='button' href={searchUrl}>
                      {translate('show.all')}
                    </a>
                  </div>
                )}

                {category === 'NoHit' && (
                  <div className='misc-result-wrapper no-result'>
                    <span className='no-hit'>{result[0].name}</span>
                  </div>
                )}

                {category !== translate('searchcategory.product') &&
                  category !== 'NoHit' &&
                  category !== 'ShowAll' && (
                    <div id={category} className='quick-search-list-wrapper'>
                      <h4>{category}</h4>
                      <ul className='quick-search-list'>
                        {result
                          .filter((o) => o.category === category)
                          .map((item, index) => {
                            return (
                              <li className='quick-search-list__list-item' key={`${item.name}-${index}`}
                              >
                                <div className='list-item__image-wrapper'>
                                  {item.hasImage && item.imageSource && (
                                    <figure>
                                      <img className='list-item__image' src={item.imageSource} />
                                    </figure>
                                  )}
                                </div>
                                <a href={item.url}>{item.name}</a>
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  )}
              </Fragment>
            );
          })}
    </div>
  );
};

export default QuickSearchResult;
